import React, { useState } from "react";
import { toast } from "react-toastify";
import { Loader } from "react-bootstrap-typeahead";
import { useEditUserDynamicFieldsMutation } from "../../Services/settingsAPIs/CommonAPI";

interface IPROPS {
    closeModal: any;
    setFieldsData: any;
    fieldsData: any;
    storingFieldData: any;
    refetch: any;
}

const EditModal: React.FC<IPROPS> = ({
    closeModal,
    setFieldsData,
    fieldsData,
    storingFieldData,
    refetch,
}) => {
    const [label, setLabel] = useState(storingFieldData?.label);
    const [required, setRequired] = useState(storingFieldData?.is_required);
    const [editable, setEditable] = useState(storingFieldData?.is_editable);
    const [unique, setUnique] = useState(storingFieldData?.is_unique);
    const [masked, setMasked] = useState(storingFieldData?.is_masked);

    const [trigger, { isLoading }] =
        useEditUserDynamicFieldsMutation();

    const saveHandler = async () => {
        const fieldObj = {
            ...storingFieldData,
            label: label,
            is_required: required,
            is_unique: unique,
            is_editable: editable,
            is_masked: masked,
        };

        try {
            const response: any = await trigger({
                id: storingFieldData.id,
                body: fieldObj,
            });

            if (response?.data) {
                toast.success("Field updated Successfully");
                closeModal(true);
                refetch();
            } else if (response?.error) {
                const apiError =
                    response?.error?.data?.non_field_errors ||
                    response?.error?.data?.detail ||
                    response?.error?.data?.message ||
                    response?.error?.message;

                if (Array.isArray(apiError) && apiError.length > 0) {
                    toast.error(apiError[0]);
                } else if (typeof apiError === "string") {
                    toast.error(apiError);
                } else {
                    toast.error("An error occured");
                }
            } else {
                toast.error("An error occured");
            }
        } catch (error) {
            toast.error("An error occured");
        }
    };

    const labelhandler = (e: any) => {
        setLabel(e.target.value);
    };

    const requiredChangeHandler = (e: any) => {
        setRequired(e.target.checked);
    };

    const uniqueChangeHandler = (e: any) => {
        setUnique(e.target.checked);
    };

    const editableChangeHandler = (e: any) => {
        setEditable(e.target.checked);
    };

    const maskedChangeHandler = (e: any) => {
        setMasked(e.target.checked);
    };

    return (
        <div>
            <div
                style={{ display: "flex", alignItems: "center", width: "100%" }}
            >
                <div style={{ width: "60%" }}>
                    <h3 style={{ display: "flex", justifyContent: "end" }}>
                        Edit Fields
                    </h3>
                </div>
                <div
                    style={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "end",
                        flex: "1",
                    }}
                >
                    <i
                        style={{
                            fontSize: "26px",
                            color: "black",
                            cursor: "pointer",
                        }}
                        className="bi bi-x"
                        onClick={() => closeModal(true)}
                    ></i>
                </div>
            </div>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    padding: "10px 0px",
                }}
            >
                <label style={{ padding: "0px 10px", fontSize: "14px" }}>
                    Label
                </label>
                <input
                    className="mx-2 form-control"
                    type="text"
                    placeholder="Label"
                    onChange={labelhandler}
                    value={label}
                />
            </div>

            <div
                style={{
                    gap: "10px",
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    padding: "10px",
                    marginBottom: "10px",
                }}
            >
                <div style={{ display: "flex", width: "100%" }}>
                    <input
                        type="checkbox"
                        onChange={requiredChangeHandler}
                        checked={required}
                    />
                    <label style={{ padding: "0px 10px", fontSize: "14px" }}>
                        Mark as required
                    </label>
                </div>
                <div style={{ display: "flex", width: "100%" }}>
                    <input
                        type="checkbox"
                        onChange={uniqueChangeHandler}
                        checked={unique}
                    />

                    <label style={{ padding: "0px 10px", fontSize: "14px" }}>
                        Mark as unique
                    </label>
                </div>
                <div style={{ display: "flex", width: "100%" }}>
                    <input
                        type="checkbox"
                        onChange={editableChangeHandler}
                        checked={editable}
                    />

                    <label style={{ padding: "0px 10px", fontSize: "14px" }}>
                        Mark as editable
                    </label>
                </div>
                <div style={{ display: "flex", width: "100%" }}>
                    <input
                        type="checkbox"
                        onChange={maskedChangeHandler}
                        checked={masked}
                        disabled={
                            storingFieldData.field_type === "check-box" ||
                            storingFieldData.field_type === "drop-down" ||
                            storingFieldData.field_type === "multi-level"
                        }
                    />

                    <label
                        style={{
                            padding: "0px 10px",
                            fontSize: "14px",
                            color:
                                storingFieldData.field_type === "check-box" ||
                                    storingFieldData.field_type === "drop-down" ||
                                    storingFieldData.field_type === "multi-level"
                                    ? "grey"
                                    : "black",
                        }}
                    >
                        Mark as masked
                    </label>
                </div>
            </div>
            <div
                style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "end",
                    gap: "20px",
                }}
            >
                <button
                    className="btn btn-light"
                    onClick={() => closeModal(true)}
                >
                    Cancel
                </button>
                <button className="btn btn-primary" onClick={saveHandler}>
                    {isLoading ? (
                        <>
                            Saving... <Loader />
                        </>
                    ) : (
                        "Save"
                    )}
                </button>
            </div>
        </div>
    );
};

export default EditModal;